// extracted by mini-css-extract-plugin
module.exports = {"heading":"hOAXf","image":"uYVBE","button":"_2R0Ff"};